module.exports = __webpack_public_path__ + "static/img/good2.fb0c3961.png";